import * as React from 'react';
import styles from './styles.module.scss';
import Image from 'next/image';

const Ticket: React.FunctionComponent<{ imageUrl: string; imageAlt: string; amount: string }> = (props) => {
  return (
    <div className={styles['ticket']}>
      <div className={styles['ticket__image']}>
        <Image
          src={props.imageUrl}
          alt={props.imageAlt}
          width={30}
          height={30}
        />
      </div>
      <div className={styles['ticket__amount']}>{props.amount}</div>
    </div>
  );
};

Ticket.displayName = 'Ticket';

export default Ticket;
